// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FlocPage_root__Q1AIv .card {
  --bs-card-border-width: 1px;
  --bs-card-cap-bg: none;
}
.FlocPage_root__Q1AIv .card .card-body {
  border: none;
}
.FlocPage_root__Q1AIv .FlocPage_media__iXTit {
  padding-top: 18px;
  padding-bottom: 18px;
}
.FlocPage_root__Q1AIv .FlocPage_flocDescHeader__TDYic {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: none;
}
.FlocPage_root__Q1AIv .FlocPage_flocDescHeader__TDYic .FlocPage_flocDescDetails__pmLsw {
  flex: 1 1;
  overflow: hidden;
}
.FlocPage_root__Q1AIv .FlocPage_flocDescHeader__TDYic .FlocPage_flocDescDetails__pmLsw .FlocPage_flocDesc__K7ePn {
  font-size: 20px;
  font-weight: 300;
  text-transform: uppercase;
  color: #111;
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Floc/FlocPage.module.scss"],"names":[],"mappings":"AACE;EACE,2BAAA;EACA,sBAAA;AAAJ;AACI;EACE,YAAA;AACN;AAGE;EACE,iBAAA;EACA,oBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAFJ;AAII;EACE,SAAA;EACA,gBAAA;AAFN;AAGM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AADR","sourcesContent":[".root {\r\n  :global(.card) {\r\n    --bs-card-border-width: 1px;\r\n    --bs-card-cap-bg: none;\r\n    :global(.card-body) {\r\n      border: none;\r\n    }\r\n  }\r\n\r\n  .media {\r\n    padding-top: 18px;\r\n    padding-bottom: 18px;\r\n  }\r\n\r\n  .flocDescHeader {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    border-bottom: none;\r\n\r\n    .flocDescDetails {\r\n      flex: 1;\r\n      overflow: hidden;\r\n      .flocDesc {\r\n        font-size: 20px;\r\n        font-weight: 300;\r\n        text-transform: uppercase;\r\n        color: #111;\r\n        text-wrap: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `FlocPage_root__Q1AIv`,
	"media": `FlocPage_media__iXTit`,
	"flocDescHeader": `FlocPage_flocDescHeader__TDYic`,
	"flocDescDetails": `FlocPage_flocDescDetails__pmLsw`,
	"flocDesc": `FlocPage_flocDesc__K7ePn`
};
export default ___CSS_LOADER_EXPORT___;
